import PAYMENT_METHODS_LABELS from './payment-methods.labels'
class PaymentMethodsManager {
  dashProgressManager

  constructor (dashProgressManager) {
    this.dashProgressManager = dashProgressManager
  }

  defaultStructure = Object.keys(PAYMENT_METHODS_LABELS)

  /**
   * parseLabel takes in a single parameter label and returns a string value by matching the label parameter
   * with the key of an object validationLabel.
   * The validationLabel object has properties that are string keys, such as 'boleto',
   * 'credit_card', 'bank_transfer', etc., and their values are string as well, such as 'payment-method.boleto',
   * 'payment-method.credit-card', 'payment-method.bank-transfer' etc.
   * @param {String} label the label to convert
   * @returns String
   */
  parseLabel (label) {
    const validationLabel = {
      ...PAYMENT_METHODS_LABELS
    }
    return validationLabel[label]
  }

  /**
   * Executes all the methods
   * @returns Array
   */
  get () {
    return this.dashProgressManager.get(this.defaultStructure, this.parseLabel)
  }
}

export default PaymentMethodsManager
